import logoDark from "~/assets/images/logo-dark.svg";
import logoLight from "~/assets/images/logo-light.svg";
import { isDark } from "~/lib/theme";

type Props = {
  width?: number;
  height?: number;
  class?: string;
};

export function Logo(props: Props) {
  return (
    <img
      src={isDark() ? logoDark : logoLight}
      alt="ScaiCRM"
      width={props.width ?? 200}
      height={props.height ?? 48}
      class={props.class}
    />
  );
}
